import { getDeviceId } from 'usage-tracker-core/common/defaultTrackers';
export const getUserExperimentIdentifier = () => getDeviceId();